import MaterialIcon from "@expo/vector-icons/MaterialCommunityIcons";
import { ComponentProps } from "react";

import { colors, TextColor } from "../theme";

export type IconName = ComponentProps<typeof MaterialIcon>["name"];

type Props = {
  em?: boolean;
  color?: TextColor;
  large?: boolean;
  name: IconName;
  size?: number;
  small?: boolean;
};

export function Icon({
  color: colorName,
  em = false,
  large = false,
  name,
  size: sizeProp,
  small = false,
}: Props) {
  const size = sizeProp ?? (large ? 32 : small ? 16 : 24);
  const color = colors[colorName ?? (em ? "accent" : "onSurface")];

  return <MaterialIcon color={color} name={name} size={size} />;
}
